module.exports = __webpack_public_path__ + "static/converge7-def2a21ac0d045961dde51523d1a1be0.jpg";